/* src/app/components/modal-help/modal-help.component.scss */
.align-item {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: none;
  box-shadow: none !important;
  width: 90%;
}
.modal-border {
  border: 4px solid #000;
}
ion-card {
  padding: 10px;
}
ion-card h3 {
  font-size: 1.4em;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}
th,
td {
  padding: 10px;
  text-align: center;
}
ion-button ion-icon {
  color: #34567e;
}
/*# sourceMappingURL=modal-help.component.css.map */
